// TODO: write documentation about fonts and typography along with guides on how to add custom fonts in own
// markdown file and add links from here

import { Platform } from "react-native"
import { 
  Ionicons, 
  MaterialIcons, 
  MaterialCommunityIcons, 
  FontAwesome5, 
  Feather, 
  Entypo, 
  AntDesign,
  Octicons,
  Zocial
} from "@expo/vector-icons"

const CDN_BASE = "https://cdn.jsdelivr.net/npm/react-native-vector-icons@10.0.0/Fonts"

export const customFontsToLoad = Platform.select({
  web: {

    ...Ionicons.font,

    // Material Icons
    'MaterialIcons': `${CDN_BASE}/MaterialIcons.ttf`,
    'material': `${CDN_BASE}/MaterialIcons.ttf`,

    // Material Community Icons
    'MaterialCommunityIcons': `${CDN_BASE}/MaterialCommunityIcons.ttf`,
    'material-community': `${CDN_BASE}/MaterialCommunityIcons.ttf`,

    // FontAwesome 5
    'FontAwesome5Free-Solid': `${CDN_BASE}/FontAwesome5_Solid.ttf`,
    'FontAwesome5Free-Regular': `${CDN_BASE}/FontAwesome5_Regular.ttf`,
    'FontAwesome5Free-Brand': `${CDN_BASE}/FontAwesome5_Brands.ttf`,

    // Otros sets
    'Feather': `${CDN_BASE}/Feather.ttf`,
    'feather': `${CDN_BASE}/Feather.ttf`,
    'Entypo': `${CDN_BASE}/Entypo.ttf`,
    'entypo': `${CDN_BASE}/Entypo.ttf`,
    'AntDesign': `${CDN_BASE}/AntDesign.ttf`,
    'anticon': `${CDN_BASE}/AntDesign.ttf`,
    'Octicons': `${CDN_BASE}/Octicons.ttf`,
    'octicons': `${CDN_BASE}/Octicons.ttf`,
    'Zocial': `${CDN_BASE}/Zocial.ttf`,
    'zocial': `${CDN_BASE}/Zocial.ttf`,
    'SimpleLineIcons': `${CDN_BASE}/SimpleLineIcons.ttf`,
    'simple-line-icons': `${CDN_BASE}/SimpleLineIcons.ttf`,
  },
  default: {
    ...Ionicons.font,
    ...MaterialIcons.font,
    ...MaterialCommunityIcons.font,
    ...FontAwesome5.font,
    ...Feather.font,
    ...Entypo.font,
    ...AntDesign.font,
    ...Octicons.font,
    ...Zocial.font,
  }
})



const fonts = {
  helveticaNeue: {
    // iOS only font.
    thin: "HelveticaNeue-Thin",
    light: "HelveticaNeue-Light",
    normal: "Helvetica Neue",
    medium: "HelveticaNeue-Medium",
  },
  Roboto:{
    normal:"Roboto"
  },
  courier: {
    // iOS only font.
    normal: "Courier",
  },
  sansSerif: {
    // Android only font.
    thin: "sans-serif-thin",
    light: "sans-serif-light",
    normal: "sans-serif",
    medium: "sans-serif-medium",
  },
  monospace: {
    // Android only font.
    normal: "monospace",
  },
}

export const typography = {
  /**
   * The fonts are available to use, but prefer using the semantic name.
   */
  fonts,
  /**
   * The primary font. Used in most places.
   */
  primary: fonts.Roboto,
  /**
   * An alternate font used for perhaps titles and stuff.
   */
  secondary: Platform.select({ ios: fonts.helveticaNeue, android: fonts.sansSerif }),
  /**
   * Lets get fancy with a monospace font!
   */
  code: Platform.select({ ios: fonts.courier, android: fonts.Roboto, web:fonts.helveticaNeue}),
}
